<template>
  <div class="dashboard-pages dashboard-content">
    <h1>This Is Dashboard Main Page</h1>
  </div>
</template>

<script>
export default {
  mounted() {
    this.setAppBarTitle({
      title: this.$t('Dashboard'),
      icon: 'dashboard'
    })
  }
}
</script>
